import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";

import { LangContext } from "../../context/LangContext";
import Bread from "../../common/Bread";

import "./cat.css";

const CSRSUbCat = () => {
  const { slug } = useParams();
  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSubCategories();
  }, [slug]);

  const fetchSubCategories = async () => {
    try {
      const res = await axios.get(
        `https://admin.icfcbank.com/api/csr/csr_sub/${slug}`,
      );
      setData(res.data.detail);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Failed to load data.</div>;

  const list = nep ? data?.np || [] : data?.en || [];
  console.log("Sub Categories List:", list);
  const breadcrumList = {
    image: "",
    link: "/csr",
    title: data?.en?.[0]?.categoryName || "",
    l1: nep ? "होम" : "Home",
    l2: nep ? "कर्पोरेट सामाजिक उत्तरदायित्व" : "CSR",
    l3: data?.en?.[0]?.categoryName || "",
  };
  console.log("slug:", slug);
  return (
    <Bread data={breadcrumList}>
      <div className="csr_cat_box">
        {list
          .filter((item) => String(item.parent_id) === String(slug))
          .map((item) => {
            const isParentFive = String(item.parent_id) === "5";

            const targetLink = isParentFive
              ? `/csr/lists/${item.id}`
              : `/csr/lists/items/${item.id}`;

            return (
              <div
                className={`cat_items ${isParentFive ? "cat_items--small" : "cat_items--x-small"}`}
                key={item.id}
              >
                <div className="cat_image">
                  {item?.DocPath ? (
                    <Link to={targetLink}>
                      <img src={item.DocPath} alt={item.Title} />
                    </Link>
                  ) : (
                    <div className="no-image">No Image</div>
                  )}
                </div>

                <div className="cat_title">
                  <h1>
                    <Link to={targetLink}>{item?.Title}</Link>
                  </h1>

                  <Link className="CSRBTN" to={targetLink}>
                    Explore
                  </Link>
                </div>
              </div>
            );
          })}
      </div>
    </Bread>
  );
};

export default CSRSUbCat;
